import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-error-icon',
  templateUrl: './communication-mail-error.component.html'
})
export class CommunicationMailErrorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
